module.exports = __webpack_public_path__ + "media/img/square-logo-small-5abfe187a40dbc07e548e5c34a699b26.png";